import styled from 'styled-components'

export const DashboardInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;
  width: 400px;
  border: 1px solid #939393;
  border-radius: 5px;
  padding: 10px 20px;
  background: #e3e3e3;
`

export const RowItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
